import styled from "@emotion/styled";
import {ICellRendererParams} from "@ag-grid-community/core";
import {renderStopTypeIcon} from "../icons/StopTypeIcons";

export const StopTypeIconCellRenderer = (props: ICellRendererParams<any>) => {
  return <StopTypeIconDiv>{renderStopTypeIcon(props.data.stopType)}</StopTypeIconDiv>;
};

const StopTypeIconDiv = styled.div`
  display: flex;
  align-items: center;
  width: 16px;
  height: 16px;
`;
